var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2ZM12.75 6H11.25V3.54004C7.16 3.90004 3.90004 7.16 3.54004 11.25H6V12.75H3.54004C3.90004 16.84 7.16 20.1 11.25 20.46V18H12.75V20.46C16.84 20.1 20.1 16.84 20.46 12.75H18V11.25H20.46C20.1 7.16 16.84 3.90004 12.75 3.54004V6ZM12.75 7.5V12.75H8V11.25H11.25V7.5H12.75Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clock_icon.10b5c727d7c8551354b5164c39a9ca93.svg";